export const GetData="getdata"
export const PostData="postdata"
export const PatchData="patchdata"
export const deleteData="deleteData"
